// ICC is the only login service, reached through this site's own backend; keep this file identical in the Harinaam and Brihad Mridanga frontends.
import axios from "axios";

const icc = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/icc-auth/`,
  timeout: 30000,
});

const unwrap = (request) => request.then((res) => res.data);

// The access token lives under "token" so the existing request interceptor keeps working unchanged.
function saveSession(data) {
  localStorage.setItem("token", data.access_token);
  localStorage.setItem("refresh_token", data.refresh_token);
  return data;
}

export function clearSession() {
  ["token", "refresh_token", "user", "account_id"].forEach((key) => localStorage.removeItem(key));
}

export const sendOtp = (phone) => unwrap(icc.post("send-otp", { phone }));

export const verifyOtp = (phone, otp) =>
  unwrap(icc.post("verify-otp", { phone, otp })).then(saveSession);

export const register = (data) => unwrap(icc.post("register", data));

export const exchangeCode = (code) => unwrap(icc.post("exchange", { code })).then(saveSession);

let refreshing = null;

// Concurrent 401s share one rotation, since each refresh token can be used only once.
export function refreshSession() {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return Promise.reject(new Error("No session"));
  if (!refreshing) {
    refreshing = unwrap(icc.post("refresh", { refresh_token: refreshToken }))
      .then(saveSession)
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

export function logout() {
  const refreshToken = localStorage.getItem("refresh_token");
  clearSession();
  if (refreshToken) icc.post("logout", { refresh_token: refreshToken }).catch(() => {});
}
